import getIcon from './__functions__/getIcon';

import SwallowedLink from './SwallowedLink';
import ButtonIcon from './ButtonIcon';
import ButtonChildren from './ButtonChildren';

import StyledButton from './__styled__/StyledButton';
import type { LinkButtonProps } from './buttonTypes';

function LinkButton(props: LinkButtonProps) {
  const {
    children,
    to,
    hash,
    href,
    disabled = false,
    $icon = null,
    $iconAfter = null,
    testId = null,
    $outline = false,
    $active = false,
    $jumbo,
    $small,
    $secondary = false,
    ...rest
  } = props;

  let asEl: React.ElementType | undefined;
  const elementProps: {
    disabled?: boolean;
    to?: string;
    href?: string;
    rel?: string;
    target?: string;
  } = {};

  if (disabled) {
    asEl = 'button';
    elementProps.disabled = true;
  } else if (to) {
    if (window?.location?.hash.replace('#', '') === to) {
      asEl = 'div';
    } else {
      asEl = SwallowedLink;
      elementProps.to = to;
    }
  } else if (href) {
    asEl = 'a';
    elementProps.href = href;
    elementProps.rel = 'noopener noreferrer';
    elementProps.target = '_blank';
  } else if (hash) {
    asEl = 'a';
    elementProps.href = hash;
  }

  const buttonOutlineReplacement = $outline && $active && !$jumbo && !$small && !$secondary;

  return (
    <StyledButton
      $isLink
      $hasIcon={Boolean(getIcon($icon, props))}
      $hasIconAfter={Boolean(getIcon($iconAfter, props))}
      $hasChildren={Boolean(children)}
      $outlineReplacement={buttonOutlineReplacement}
      $outline={$outline}
      $jumbo={$jumbo}
      $active={$active}
      $small={$small}
      $secondary={$secondary}
      data-test-id={testId}
      as={asEl}
      {...rest}
      {...elementProps}
    >
      <div>
        {$icon && <ButtonIcon {...props} displayIcon={getIcon($icon, props)} />}
        {children && <ButtonChildren {...props}>{children}</ButtonChildren>}
        {$iconAfter && <ButtonIcon {...props} displayIcon={getIcon($iconAfter, props)} />}
      </div>
    </StyledButton>
  );
}

export default LinkButton;
